import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';

export class ApiKeyConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string;
	dateCreated = DateTime.now();
	lastUpdated = DateTime.now();
	objectState?: ObjectState;

	value?: string;
	expiry?: DateTime;
	userID?: string;

	constructor(init?: Partial<ApiKeyConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
